module.exports = __webpack_public_path__ + "static/media/pedia sure complete.176aac4e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/pedia sure complete.gif
// module id = 375
// module chunks = 0